<ng-container *ngIf="(isLoading$ | async) === false">
    <div class="my-4 hidden md:block">
        <h1 class="text-base font-bold leading-5">{{ 'CITY_TICKET_PERIOD' | translate }}</h1>
    </div>
    <div class="w-auto max-w-full overflow-y-auto dark:bg-contrast-black md:rounded-lg md:bg-grey-white_smoke md:p-4">
        <div class="mb-4 bg-white shadow-md">
            <div class="flex justify-between">
                <div>
                    <p
                        class="text-bold p-4 text-left text-base font-bold leading-5 text-grey-dark dark:filter-yellow md:hidden">
                        {{ categoryFromPreviousStep?.name | translateObjectField: null : currentLanguage }}
                        <span *ngIf="!categoryFromPreviousStep && env.IS_NEW_AFC">
                            {{ fareDisplayText }}
                        </span>
                        <span *ngIf="chosenAreasFromPreviousStep?.length > 1">
                            {{ 'WITHIN_ZONES' | translate }}
                            {{
                                chosenAreasFromPreviousStep[0].name + ' ' + chosenAreasFromPreviousStep[1]?.name
                                    | translateObjectField: null : currentLanguage
                            }}
                        </span>
                        <span *ngIf="chosenAreasFromPreviousStep?.length === 1">
                            {{ 'WITHIN_ZONE' | translate }}
                            {{ chosenAreasFromPreviousStep[0].name | translateObjectField: null : currentLanguage }}
                        </span>
                    </p>
                </div>

                <ng-container *ngIf="isNewAFC && productDescription" [ngTemplateOutlet]="newAfcInfoBtn"></ng-container>
            </div>

            <ng-container *ngIf="showProductInfo" [ngTemplateOutlet]="newAfcInfoBlock"></ng-container>
        </div>

        <div class="content w-auto bg-grey-white_smoke shadow-md dark:bg-contrast-black">
            <div
                class="orb-app-light:shadow-md var-app-light:shadow-md bg-white p-4"
                *ngIf="(showDateSelection$ | async) === false">
                <p
                    class="mb-2 text-sm font-semibold uppercase leading-5 tracking-wider text-grey-dark dark:filter-yellow"
                    [class.normal-case]="env.REMOVE_UPPERCASE">
                    {{ 'TICKET_TYPE' | translate }}
                </p>
                <div
                    class="border-t border-solid border-black border-opacity-10 dark:border-contrast-yellow"
                    *ngFor="let productTravellerType of productTravellerTypes">
                    <div
                        class="flex flex-col gap-1 py-4"
                        [attr.aria-label]="productTravellerType?.ariaLabel"
                        role="group"
                        tabindex="0">
                        <div class="flex justify-between gap-2" aria-hidden="true">
                            <p class="text-base font-bold leading-5">
                                {{
                                    (env.IS_NEW_AFC
                                        ? productTravellerType?.userProfiles[0].name
                                        : productTravellerType?.name
                                    ) | translateObjectField: null : currentLanguage
                                }}
                            </p>
                            <div
                                class="whitespace-nowrap text-base leading-5"
                                *ngIf="!productTravellerType?.isDynamicLength"
                                [ngClass]="{
                                    'font-bold': productTravellerType?.amount > 0,
                                    'font-medium': !(productTravellerType?.amount > 0)
                                }">
                                {{ productTravellerType?.price?.amount | moneyFormat }}
                                {{ env.CURRENCY || productTravellerType?.price?.currency || currency }}
                            </div>
                        </div>

                        <ng-container
                            *ngIf="isNewAFC"
                            [ngTemplateOutlet]="userProfilesInfo"
                            [ngTemplateOutletContext]="{ productTravellerType: productTravellerType }"></ng-container>
                        <p class="text-base font-normal leading-5" *ngIf="!isNewAFC" aria-hidden="true">
                            {{ productTravellerType?.descriptionValue }}
                        </p>
                    </div>

                    <div
                        class="flex justify-end pb-4"
                        *ngIf="purchaseService.isDynamicLengthProduct(productTravellerType)">
                        <button
                            class="product solid-border flex items-center justify-between gap-4 px-4 py-2 text-left focus:outline-none focus:ring-2 focus:ring-blue-500"
                            (click)="addAmount(productTravellerType?.id)">
                            <div class="product-info flex-1 text-base">
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    {{ 'PURCHASE_FLOW_V2_SELECT_PERIOD' | translate }}
                                </p>
                            </div>
                            <div class="flex flex-col justify-center p-2 dark:filter-yellow">
                                <ion-icon
                                    class="text-black"
                                    title="chevron"
                                    aria-hidden="true"
                                    name="chevron-forward-outline"></ion-icon>
                            </div>
                        </button>
                    </div>

                    <div
                        class="orb-app-light-dark:justify-between var-app-light-dark:justify-between flex justify-end pb-4"
                        *ngIf="!purchaseService.isDynamicLengthProduct(productTravellerType)">
                        <p class="flex-align-center flex text-base leading-5" *ngIf="env.IS_NEW_AFC">
                            {{ 'AMOUNT' | translate }}
                        </p>
                        <div class="flex">
                            <ion-button
                                class="orb-app-light:bg-primary tartu-light:bg-[var(--btn-primary-color)] vl-app-light:bg-[var(--btn-primary-color)] content-product__amount_remove left amount m-0 h-14 w-14 bg-secondary dark:bg-contrast-yellow"
                                [attr.aria-label]="'ACTION_DECREASE_AMOUNT_TITLE' | translate"
                                [disabled]="productTravellerType?.amount === 0"
                                (click)="removeAmount(productTravellerType?.id)"
                                color="none">
                                <ion-icon
                                    class="orb-app-light:text-black vl-app-light:text-black var-app-light-dark:text-black text-white dark:text-contrast-black"
                                    [ngClass]="{
                                        'orb-app-light:text-black/50 var-app-light-dark:text-black/50':
                                            productTravellerType?.amount === 0
                                    }"
                                    name="remove"></ion-icon>
                            </ion-button>
                            <div
                                class="content-product__amount flex h-14 w-12 items-center justify-center bg-grey-white_smoke text-base font-bold leading-5 dark:bg-contrast-black">
                                {{ productTravellerType?.amount }}
                            </div>
                            <ion-button
                                class="orb-app-light:bg-primary tartu-light:bg-[var(--btn-primary-color)] vl-app-light:bg-[var(--btn-primary-color)] content-product__amount_add right amount m-0 h-14 w-14 bg-secondary dark:bg-contrast-yellow"
                                [attr.aria-label]="'ADD' | translate"
                                [disabled]="(isAddButtonDisabledForType$ | async)?.[productTravellerType?.id]"
                                (click)="addAmount(productTravellerType?.id)"
                                color="none">
                                <ion-icon
                                    class="orb-app-light:text-black vl-app-light:text-black var-app-light:text-black text-white dark:text-contrast-black"
                                    name="add"></ion-icon>
                            </ion-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Date selection view -->
            <div class="bg-white p-4" *ngIf="(showDateSelection$ | async) === true">
                <ng-container *ngIf="selectedProductForDateSelection$ | async as selectedProduct">
                    <p
                        class="mb-6 text-sm font-semibold uppercase leading-5 tracking-wider text-grey-dark dark:filter-yellow"
                        [class.normal-case]="env.REMOVE_UPPERCASE">
                        {{ 'SET_DATE' | translate }}
                    </p>

                    <div class="mb-4">
                        <p class="text-base font-bold leading-5">
                            {{
                                (env.IS_NEW_AFC ? selectedProduct?.userProfiles[0].name : selectedProduct?.name)
                                    | translateObjectField: null : currentLanguage
                            }}
                        </p>
                        <p class="text-sm text-grey-dark dark:text-contrast-yellow">
                            {{ 'PERIOD_TICKET_TEXT_SELECT_OWN_RANGE_DAYS_IN_PERIOD' | translate }}
                            {{ dynamicTicketRangeTotalDays }} {{ 'DAYS' | translate }}
                        </p>
                        <p class="text-sm text-grey-dark dark:text-contrast-yellow">
                            {{ 'JOINT_TICKET_MAX_LENGTH_DESC' | translate }}
                        </p>
                    </div>

                    <div class="date-selectors-row mb-4 flex justify-center gap-4">
                        <!-- From date -->
                        <div class="starting-point flex-1">
                            <div class="date-selector-ionic">
                                <label class="mb-2 block text-sm font-medium">{{
                                    'CHOOSE_VALIDITY_FROM' | translate
                                }}</label>
                                <ion-button
                                    class="date-trigger-button w-full"
                                    id="start-date-trigger"
                                    expand="block"
                                    fill="outline">
                                    <div class="flex w-full items-center justify-between">
                                        <span>{{
                                            dynamicTicketStartDateForDisplay$ | async | date: 'dd.MM.yyyy'
                                        }}</span>
                                        <ion-icon name="calendar-outline"></ion-icon>
                                    </div>
                                </ion-button>
                                <ion-modal
                                    #startDateModal
                                    [keepContentsMounted]="true"
                                    trigger="start-date-trigger"
                                    cssClass="datetime-modal datetime-modal-left">
                                    <ng-template>
                                        <ion-datetime
                                            #startDatePicker
                                            [value]="dynamicTicketStartDateISO$ | async"
                                            [min]="dynamicTicketMinDateISO$ | async"
                                            [max]="dynamicTicketMaxDateISO$ | async"
                                            [locale]="locale"
                                            [firstDayOfWeek]="1"
                                            (ionChange)="onDynamicStartDateChange($event)"
                                            presentation="date">
                                        </ion-datetime>
                                    </ng-template>
                                </ion-modal>
                            </div>
                        </div>

                        <!-- To date -->
                        <div class="ending-point flex-1">
                            <div class="date-selector-ionic">
                                <label class="mb-2 block text-sm font-medium">{{
                                    'CHOOSE_VALIDITY_TO' | translate
                                }}</label>
                                <ion-button
                                    class="date-trigger-button w-full"
                                    id="end-date-trigger"
                                    expand="block"
                                    fill="outline">
                                    <div class="flex w-full items-center justify-between">
                                        <span>{{ dynamicTicketEndDateForDisplay$ | async | date: 'dd.MM.yyyy' }}</span>
                                        <ion-icon name="calendar-outline"></ion-icon>
                                    </div>
                                </ion-button>
                                <ion-modal
                                    #endDateModal
                                    [keepContentsMounted]="true"
                                    trigger="end-date-trigger"
                                    cssClass="datetime-modal datetime-modal-right">
                                    <ng-template>
                                        <ion-datetime
                                            #endDatePicker
                                            [value]="dynamicTicketEndDateISO$ | async"
                                            [min]="dynamicTicketStartDateISO$ | async"
                                            [max]="dynamicTicketMaxEndDateISO$ | async"
                                            [locale]="locale"
                                            [firstDayOfWeek]="1"
                                            (ionChange)="onDynamicEndDateChange($event)"
                                            presentation="date">
                                        </ion-datetime>
                                    </ng-template>
                                </ion-modal>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div
        class="activation-date-section mt-4 bg-white p-4 shadow-md md:rounded-lg md:bg-grey-white_smoke"
        *ngIf="env.ENABLE_CHOOSE_STARTING_DATE && (is30DayTicket$ | async)">
        <div class="md:rounded md:bg-white md:p-4">
            <p
                class="mb-4 text-sm font-semibold uppercase leading-5 tracking-wider text-grey-dark dark:filter-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE">
                {{ 'ACTIVATE_DATE' | translate }}
            </p>

            <ion-segment class="mb-4" [value]="activationMode$ | async" (ionChange)="onActivationModeChange($event)">
                <ion-segment-button class="dark:text-contrast-yellow" [value]="ActivationMode.IMMEDIATELY">
                    <ion-label>{{ 'ACTIVATE_TICKET_PURCHASE' | translate }}</ion-label>
                </ion-segment-button>
                <ion-segment-button class="dark:text-contrast-yellow" [value]="ActivationMode.SPECIFIC_DATE">
                    <ion-label>{{ 'ACTIVATE_TICKET_SPECIFIED_ACTIVATION_DATE' | translate }}</ion-label>
                </ion-segment-button>
            </ion-segment>

            <div
                class="mb-3 rounded bg-grey-white_smoke p-3 dark:bg-contrast-black"
                *ngIf="(activationMode$ | async) === ActivationMode.SPECIFIC_DATE">
                <p class="text-sm text-grey-dark dark:bg-contrast-black dark:text-contrast-yellow">
                    {{ 'CHOOSE_STARTING_TIME_DESCRIPTION' | translate }}
                </p>
            </div>

            <ion-datetime
                class="w-full"
                *ngIf="(activationMode$ | async) === ActivationMode.SPECIFIC_DATE"
                [min]="minDate"
                [max]="maxDateISO$ | async"
                [locale]="locale"
                [firstDayOfWeek]="1"
                (ionChange)="onDateChange($event)"
                presentation="date">
            </ion-datetime>

            <div
                class="mt-3 rounded bg-grey-white_smoke p-3 dark:bg-contrast-black"
                *ngIf="activationMode$ | async as mode">
                <p class="text-sm text-grey-dark dark:text-contrast-yellow" *ngIf="mode === ActivationMode.IMMEDIATELY">
                    {{ 'TICKET_ACTIVATE_IMMEDIATELY' | translate }}
                </p>
                <p
                    class="text-sm text-grey-dark dark:text-contrast-yellow"
                    *ngIf="mode === ActivationMode.SPECIFIC_DATE && (selectedStartingDate$ | async) as selectedDate">
                    {{ 'TICKET_WILL_ACTIVATE_ON' | translate }} {{ selectedDate.toString() }}
                </p>
                <p
                    class="text-sm text-grey-dark dark:text-contrast-yellow"
                    *ngIf="mode === ActivationMode.SPECIFIC_DATE && (selectedStartingDate$ | async) === null">
                    {{ 'PLEASE_SELECT_STARTING_DATE' | translate }}
                </p>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #newAfcInfoBtn>
    <div class="flex items-center">
        <ion-button
            *ngIf="!showProductInfo"
            [aria-label]="'PURCHASE_V2_PRODUCT_EXPAND_PRODUCT_INFO' | translate"
            (click)="showProductInfo = !showProductInfo"
            fill="clear">
            <ridango-ui-icons
                class="product-info-icon h-6x2 w-6x2"
                *ngIf="!showProductInfo"
                [ngClass]="{ 'product-info-icon--high-contrast': isHighContrast }"
                [name]="'productInfo'"
                aria-hidden="true">
            </ridango-ui-icons>
        </ion-button>
    </div>
</ng-template>

<ng-template #newAfcInfoBlock>
    <div class="px-4 pb-4x2">
        <div
            class="rounded-lg bg-grey-white_smoke px-2x2 py-[0.4375rem] dark:border dark:border-solid dark:border-contrast-yellow dark:bg-transparent">
            <div
                class="flex items-center gap-x-4"
                [attr.aria-label]="('PURCHASE_V2_PRODUCT_PRODUCT_DESCRIPTION' | translate) + ' ' + productDescription">
                <div class="flex h-6x2 w-6x2">
                    <ridango-ui-icons
                        class="product-info-icon h-6x2 w-6x2"
                        [ngClass]="{ 'product-info-icon--high-contrast': isHighContrast }"
                        [name]="'productInfo'"
                        aria-hidden="true">
                    </ridango-ui-icons>
                </div>
                <div class="orb-app-light:text-secondary flex w-full items-center justify-between leading-5">
                    <p>{{ productDescription }}</p>
                    <div class="h-6x2 w-6x2">
                        <ion-icon
                            class="var-app-light:text-primary h-6x2 w-6x2 cursor-pointer dark:text-contrast-yellow"
                            *ngIf="showProductInfo"
                            [src]="(assetsPath$ | async) + '/img/explore/cross.svg'"
                            [aria-label]="'PURCHASE_V2_PRODUCT_COLLAPSE_PRODUCT_INFO' | translate"
                            (click)="showProductInfo = !showProductInfo"
                            slot="icon-only"
                            role="button">
                        </ion-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #userProfilesInfo let-productTravellerType="productTravellerType">
    <p
        class="font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
        *ngIf="
            productComponentUtil.getUserProfilesInfo(
                productTravellerType,
                translatePipe,
                translate,
                currentLanguage
            ) as userProfilesInfo
        ">
        {{ userProfilesInfo }}
    </p>
</ng-template>
